import { PaginatedDataDTO, PaginationQueryParamsDTO } from '@bottega52/commons-pagination';
import jwt from 'jsonwebtoken';
import _ from 'lodash';
import * as UserDecoder from '../../codec/userInDTODecoder';
import * as AuthApi from '../../repository/jago/authAPI';
import * as FreshDeskAPI from '../../repository/jago/freshDeskAPI';
import { IUserFormDTO } from '../../repository/jago/model/input/IUserFormDTO';
import { IUserInDTO } from '../../repository/jago/model/input/IUserInDTO';
import { IUserRoleInDTO } from '../../repository/jago/model/input/IUserRoleInDTO';
import { IVarInDTO } from '../../repository/jago/model/input/IVarInDTO';
import { IUserOutDTO } from '../../repository/jago/model/output/IUserOutDTO';
import { IUserRequestParamsDTO } from '../../repository/jago/model/output/RequestParamsDTOs';
import * as OtpApi from '../../repository/jago/otpAPI';
import * as UsersAPI from '../../repository/jago/usersAPI';
import * as AuthService from '../../services/AuthService';
import * as SettingsActions from '../settings/settings.actions';
import * as CreditsActions from '../credits/credits.actions';
import * as amplitude from '@amplitude/analytics-browser';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import PermissionsParserProvider from '../../services/PermissionService/PermissionsParserProvider';
import { LocalStorageRepository } from '../../services/StorageService/LocalStorageRepository';
import { IState } from '../store';
import { ActionsUnion, createAction, IThunkAction } from '../utils';
import { IUserDecodedJWT } from './../../repository/jago/model/input/IUserDecodedJWT';
import { Roles } from './../../services/PermissionService/PermissionConstants';
import UserActionTypesEnum from './model/UserActionTypesEnum';
import { IUsersInterface } from './user.reducers';
import { LANGUAGE_DETAILS } from '../../utils/LanguageUtils';
import { IUserDataOutDTO } from '../../repository/jago/model/output/IUserDataOutDTO';
import { IAccessRequestFormDTO } from '../../repository/jago/model/input/IAccessRequestFormDTO';



export const UserActions = {
  saveUserData: createAction<typeof UserActionTypesEnum.SAVE_USER_DATA, any>(UserActionTypesEnum.SAVE_USER_DATA),
  setUserAuthenticated: createAction<typeof UserActionTypesEnum.SET_USER_AUTHENTICATION, boolean>(UserActionTypesEnum.SET_USER_AUTHENTICATION),
  saveUsers: createAction<typeof UserActionTypesEnum.SAVE_USERS, PaginatedDataDTO<IUserInDTO>>(UserActionTypesEnum.SAVE_USERS),
  saveUsersRoles: createAction<typeof UserActionTypesEnum.SAVE_USERS_ROLES, PaginatedDataDTO<IUserRoleInDTO>>(UserActionTypesEnum.SAVE_USERS_ROLES),
  setSelectedUser: createAction<typeof UserActionTypesEnum.SET_SELECTED_USER, IUserInDTO | {}>(UserActionTypesEnum.SET_SELECTED_USER),
  resetUserData: createAction<typeof UserActionTypesEnum.RESET_USER_UDATA>(UserActionTypesEnum.RESET_USER_UDATA),
};

export function setUserInfoFromLocalStorage(): IThunkAction<IUsersInterface, IState> {
  return (dispatch, getState) => {
    const storage = new LocalStorageRepository();
    const { user } = getState();
    if (_.isEmpty(user.userData)) {
      const token = storage.readKey<string>('token', '');
      if (token) {
        const decodedJWT= jwt.decode(token) as IUserDecodedJWT;
        let userRoles: string[] = [];
        if (decodedJWT) {
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_SOFIA_ADMIN))
            userRoles.push(Roles.ROLE_VASHO_SOFIA_ADMIN);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_GLOBAL_SEGMENT_LEADER))
            userRoles.push(Roles.ROLE_VASHO_GLOBAL_SEGMENT_LEADER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_GLOBAL_SALES_OPERATION_MANAGER))
            userRoles.push(Roles.ROLE_VASHO_GLOBAL_SALES_OPERATION_MANAGER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_SALES_OPERATION_MANAGER))
            userRoles.push(Roles.ROLE_VASHO_SALES_OPERATION_MANAGER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_MARKET_LEADER))
            userRoles.push(Roles.ROLE_VASHO_MARKET_LEADER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_EUSM))
            userRoles.push(Roles.ROLE_VASHO_EUSM);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_KAM))
            userRoles.push(Roles.ROLE_VASHO_KAM);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_GLOBAL_SOC_MANAGER))
            userRoles.push(Roles.ROLE_VASHO_GLOBAL_SOC_MANAGER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_LOCAL_SOC_MANAGER))
            userRoles.push(Roles.ROLE_VASHO_LOCAL_SOC_MANAGER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_VAR_ADMIN))
            userRoles.push(Roles.ROLE_VASHO_VAR_ADMIN);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_VAR_SALES_MANAGER))
            userRoles.push(Roles.ROLE_VASHO_VAR_SALES_MANAGER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_VAR_SALES_REPRESENTATIVE))
            userRoles.push(Roles.ROLE_VASHO_VAR_SALES_REPRESENTATIVE);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_VAR_SUPPORT))
            userRoles.push(Roles.ROLE_VASHO_VAR_SUPPORT);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_MKS_MANAGER))
            userRoles.push(Roles.ROLE_MKS_MANAGER);
          if (decodedJWT.authorities.some(e=>e===Roles.ROLE_VASHO_DEVELOPER_ADMIN))
            userRoles.push(Roles.ROLE_VASHO_DEVELOPER_ADMIN);
        }

        if (!userRoles.length) {
          dispatch(userLogout());
          return;
        }

        AbilityProvider.getAbilityHelper().setUserRole(userRoles);
        if (PermissionsParserProvider.getPermissionsParser().parse(userRoles)) {
          AbilityProvider.getAbilityHelper().setUserPermissions(PermissionsParserProvider.getPermissionsParser().parse(userRoles));
        }
        const rolePermissions = AbilityProvider.getAbilityHelper().userPermissions;
        const decodedToSave = {
          ..._.omit(decodedJWT, 'authorities'),
          authorities: userRoles,
          rolePermissions
        };
        amplitude.setUserId(String(decodedJWT.user_name));
        dispatch(UserActions.saveUserData(decodedToSave || {}));
        storage.storeKey('isAuthenticated', true);
        dispatch(UserActions.setUserAuthenticated(true));
        AuthService.setRequestInterceptor(token);
        // SET INTERCEPTORS
      } else {
        storage.storeKey('isAuthenticated', false);
        dispatch(UserActions.setUserAuthenticated(false));
      }
    }
    return getState().user;
  }
}

export function userJagoLoginWithGoogle(googleToken: string): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    try {
      const storage = new LocalStorageRepository();
      const authResponse = await AuthApi.jagoLoginWithGoogle({ token: googleToken });
      if (authResponse && authResponse.data && authResponse.data.token) {
        AuthService.setRequestInterceptor(authResponse.data.token);
        storage.storeKey('token', authResponse.data.token);
        storage.storeKey('isAuthenticated', true);
        dispatch(setUserInfoFromLocalStorage());
        dispatch(fetchUserData());
      }
    } catch (error) {
      throw error;
    }
  }
}

export function updateCurrentUserData(data: IUserDataOutDTO): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    try {
      const response = await UsersAPI.updateCurrentUserData(data);
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      throw error;
    }
  }
}

export function fetchUserData(): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    try {
      const response = await UsersAPI.fetchCurrentUserData();      
      if (response && response.data) {
        const { userData } = getState().user;
        const mergedUserData = {
          ...userData,
          ...response.data
        };
        dispatch(UserActions.saveUserData(mergedUserData));
        if (mergedUserData.languageType) {
          const storage = new LocalStorageRepository();
          const languageToSave = _.find(LANGUAGE_DETAILS, e => e.name === mergedUserData.languageType);
          if (languageToSave) {
            dispatch(SettingsActions.saveLanguageSettings(languageToSave.lang));
            storage.storeKey('language', languageToSave.lang);
          }
        }
        
        await dispatch<any>(CreditsActions.fetchClusters());
        try {
          await dispatch<any>(SettingsActions.fetchParamPublicConfiguration());
        } catch (error) {
          console.error('Error fetching param configurations:', error);
        }
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  }
}

export function sendOTPEmail(email: string): IThunkAction<void, IState> {
  return async () => {
    try {
      await OtpApi.sendOTPViaEmail({ email });
    } catch (error) {
      throw error;
    }
  }
}

export function userJagoLoginWithOTP(code: string): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    try {
      const storage = new LocalStorageRepository();
      // TODO: FIX ME
      const authResponse = await OtpApi.verifyOTP({ code });
      if (authResponse && authResponse.data && authResponse.data.token) {
        AuthService.setRequestInterceptor(authResponse.data.token);
        storage.storeKey('token', authResponse.data.token);
        storage.storeKey('isAuthenticated', true);
        await dispatch(setUserInfoFromLocalStorage());
        dispatch(fetchUserData());
      }
    } catch (error) {
      throw error;
    }
  }
}


export function userLogout(): IThunkAction<void, IState> {
  return (dispatch, getState) => {
    const storage = new LocalStorageRepository();
      storage.storeKey<string>('token', '');
      storage.storeKey<string>('user', '');
      storage.storeKey('isAuthenticated', false);
      dispatch(UserActions.saveUserData({}));
      dispatch(UserActions.setUserAuthenticated(false));
      amplitude.reset();
      AuthService.ejectRequestInterceptor();
  }
}

export function openAccessRequestTicket(formData: IAccessRequestFormDTO): IThunkAction<void, IState> {
  return async () => {
    try {
      const ticketDTO = {
        description: (`
        <div>
          <h4>VASHO Access Request</h4>
          <p><strong>First name:</strong> ${formData.firstName}</p>
          <p><strong>Last name:</strong> ${formData.lastName}</p>
          <p><strong>Company:</strong> ${formData.companyName}</p>
          <p><strong>Email:</strong> ${formData.email}</p>
        </div>
        `),
        email: formData.email,
        subject: `VASHO - Access Request`,
        group_id: 2043001794126, // DO NOT EDIT: IF NECESSARY, CONTACT SOFIA
        status: 2,
        priority: 3,
        source: 9,
      };
      const ticketResponse = await FreshDeskAPI.createFreshdeskTicket(ticketDTO);
      return ticketResponse;
    } catch (error) {
      throw error;
    }
  }
}

export function openLearingTicket(ticketBody: string): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    const { userData } = getState().user;
    const { VAR: { data } } = getState().vars;
    const varData = data as IVarInDTO;
    try {
      const email = userData.user_name || 'no-email';
      const ticketDTO = {
        description: (`
        <div>
          <h4>Learning Request from VAR ${varData && !_.isEmpty(varData) ? varData.name : ''}. Requester ${email}</h4>
          "${ticketBody}"
        </div>
        `),
        email,
        subject: `VASHO - Learning Request`,
        group_id: 2043001794126, // DO NOT EDIT: IF NECESSARY, CONTACT SOFIA
        status: 2,
        priority: 3,
        source: 9,
      };
      const ticketResponse = await FreshDeskAPI.createFreshdeskTicket(ticketDTO);
      return ticketResponse;
    } catch (error) {
      throw error;
    }
  }
} 

export function openCloseDomainTicket(domainName: string): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    const { userData } = getState().user;
    const { VAR: { data } } = getState().vars;
    const varData = data as IVarInDTO;
    try {
      const email = userData.user_name || 'no-email';
      const ticketDTO = {
        description: (`
        <div>
          <h4>Close Domain Request from VAR ${varData && !_.isEmpty(varData) ? varData.name : ''}. Requester ${email}</h4>
          <h4>Domain: ${domainName}</h4>
        </div>
        `),
        email,
        subject: `VASHO - Close Domain Request`,
        group_id: 2043001817543, // DO NOT EDIT: IF NECESSARY, CONTACT SOFIA
        status: 2,
        priority: 3,
        source: 9,
        email_config_id: 44000172102,
      };
      const ticketResponse = await FreshDeskAPI.createFreshdeskTicket(ticketDTO);
      return ticketResponse;
    } catch (error) {
      throw error;
    }
  }
} 

export function openCloseCustomerTicket(customerId: number, customerName: string): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    const { userData } = getState().user;
    const { VAR: { data } } = getState().vars;
    const varData = data as IVarInDTO;
    try {
      const email = userData.user_name || 'no-email';
      const ticketDTO = {
        description: (`
        <div>
          <h4>Delete Customer Request from VAR ${varData && !_.isEmpty(varData) ? varData.name : ''}. Requester ${email}</h4>
          <h4>Customer ID: ${customerId}</h4>
          <h4>Customer name: ${customerName}</h4>
        </div>
        `),
        email,
        subject: `VASHO - Delete Customer Request`,
        group_id: 2043001817543, // DO NOT EDIT: IF NECESSARY, CONTACT SOFIA
        status: 2,
        priority: 3,
        source: 9,
        email_config_id: 44000172102,
      };
      const ticketResponse = await FreshDeskAPI.createFreshdeskTicket(ticketDTO);
      return ticketResponse;
    } catch (error) {
      throw error;
    }
  }
} 

export function openCloseWalletTicket(walletId: number, walletName: string): IThunkAction<void, IState> {
  return async (dispatch, getState) => {
    const { userData } = getState().user;
    const { VAR: { data } } = getState().vars;
    const varData = data as IVarInDTO;
    try {
      const email = userData.user_name || 'no-email';
      const ticketDTO = {
        description: (`
        <div>
          <h4>Close Wallet Request from VAR ${varData && !_.isEmpty(varData) ? varData.name : ''}. Requester ${email}</h4>
          <h4>Wallet ID: ${walletId}</h4>
          <h4>Wallet: ${walletName}</h4>
        </div>
        `),
        email,
        subject: `VASHO - Close Wallet Request`,
        group_id: 2043001817543, // DO NOT EDIT: IF NECESSARY, CONTACT SOFIA
        status: 2,
        priority: 3,
        source: 9,
        email_config_id: 44000172102,
      };
      const ticketResponse = await FreshDeskAPI.createFreshdeskTicket(ticketDTO);
      return ticketResponse;
    } catch (error) {
      throw error;
    }
  }
} 

export function fetchUsers(params: IUserRequestParamsDTO = { page: 0, pageSize: 1000 }): IThunkAction<Promise<PaginatedDataDTO<IUserInDTO>>, IState> {
  return async (dispatch, getState) => {
    try {
      const response = await UsersAPI.fetchUsers(params);
      if (response && response.data) {
        const decodedData = UserDecoder.decode(response.data);
        dispatch(UserActions.saveUsers(decodedData));
        return decodedData;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function fetchUsersRoles(params: PaginationQueryParamsDTO = { page: 0, pageSize: 1000 }): IThunkAction<Promise<PaginatedDataDTO<IUserRoleInDTO>>, IState> {
  return async (dispatch, getState) => {
    try {
      const response = await UsersAPI.fetchUsersRoles(params);
      if (response && response.data) {
        const decodedData = UserDecoder.decodeRoles(response.data);
        dispatch(UserActions.saveUsersRoles(decodedData));
        return decodedData;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function setSelectedUser(user: IUserInDTO | {}): IThunkAction<void, IState> {
  return (dispatch ) => {
    dispatch(UserActions.setSelectedUser(user));
  }
}

export function resetUserData(): IThunkAction<void, IState> {
  return (dispatch ) => {
    dispatch(UserActions.resetUserData());
  }
}

export function deleteUser(userId: number): IThunkAction<void, IState> {
  return async () => {
    try {
      const deleteResponse = await UsersAPI.deleteUser(userId);
      if (deleteResponse && deleteResponse.data) {
        return deleteResponse.data;
      }
    } catch (error) {
      throw error;
    }
  }
}

export function createNewUser(newUserData: IUserFormDTO): IThunkAction<void, IState> {
  return async () => {
    try {
      const newUser: IUserOutDTO = UserDecoder.encodeUserFromForm(newUserData);
      const createResponse = await UsersAPI.createNewUser(newUser);
      if (createResponse && createResponse.data) {
        return createResponse.data;
      }
    } catch (error) {
      throw error;
    }
  }
}

export function editUser(userId: number, newUserData: IUserFormDTO): IThunkAction<void, IState> {
  return async () => {
    try {
      const newUser: IUserOutDTO ={
        ...UserDecoder.encodeUserFromForm(newUserData),
        email: undefined,
      };
      const updateResponse = await UsersAPI.editUser(userId, newUser);
      if (updateResponse && updateResponse.data) {
        return updateResponse.data;
      }
    } catch (error) {
      throw error;
    }
  }
}

export type UserActionsType = ActionsUnion<typeof UserActions>;
